import AntIcon from "@/components/icons/AntIcon";
import Ellipsis from "@/components/views/Ellipsis";
import { useWindowSize } from "@/utils/hooksUtils";
import { cssVariables, isDefined } from "@/utils/utils";
import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";
import { DASHBOARD_LARGER_SCREEN_UPDATE_WIDTH } from "../../../../utils";
import styles from "../../statistics/DashboardStatisticsWidget.module.scss";
import { StatDivider } from "./common/StatDivider";
import { StatNumber } from "./common/StatNumber";
import { STATS_HEIGHT } from "./common/utils";

type Props = {
  data: {
    missingPoints?: number;
    missingEducations?: number;
  };
};

export const FinancialAcademyData = ({ data }: Props) => {
  const { t } = useTranslation();

  const windowSize = useWindowSize();

  return (
    <>
      <Flex align="center">
        <Button className={styles.labelIcon} variant="filled" color="cyan" icon={<AntIcon type="euro" />} />

        <Ellipsis>
          <span
            style={{
              fontSize: windowSize.innerWidth >= DASHBOARD_LARGER_SCREEN_UPDATE_WIDTH ? 21 : 18,
              paddingLeft: 8,
            }}
          >
            {t("dashboard.statisticsExtended.financialAcademy")}
          </span>
        </Ellipsis>
      </Flex>

      <Flex className="margin-top-tiny" style={{ height: STATS_HEIGHT }}>
        {isDefined(data.missingPoints) ? (
          <div style={{ textAlign: isDefined(data.missingPoints) ? "right" : "center", flex: 1 }}>
            <div style={{ color: cssVariables.colorGrey }}>{t("dashboard.statisticsExtended.points")}</div>

            <StatNumber value={data.missingPoints} />
          </div>
        ) : undefined}

        {isDefined(data.missingPoints) && isDefined(data.missingEducations) ? <StatDivider /> : undefined}

        {isDefined(data.missingEducations) ? (
          <div style={{ flex: 1, textAlign: isDefined(data.missingEducations) ? undefined : "center" }}>
            <div style={{ color: cssVariables.colorGrey }}>{t("dashboard.statisticsExtended.educations")}</div>

            <StatNumber value={data.missingEducations} />
          </div>
        ) : undefined}
      </Flex>

      <Ellipsis style={{ color: cssVariables.colorGrey, textAlign: "center" }}>
        {t("dashboard.statisticsExtended.helpers.toCompleteAcademy")}
      </Ellipsis>
    </>
  );
};
